import {useMediaQuery} from "@mui/material";

const useCurrentScreenSize = () => {
  const isXsScreen = useMediaQuery("(max-width:600px)");
  const isSmScreen = useMediaQuery("(min-width:600px) and (max-width:960px)");
  const isMdScreen = useMediaQuery("(min-width:960px) and (max-width:1280px)");
  const isLgScreen = useMediaQuery("(min-width:1280px) and (max-width:1920px)");
  const isXlScreen = useMediaQuery("(min-width:1920px)");

  if (isXsScreen) return "xs";
  if (isSmScreen) return "sm";
  if (isMdScreen) return "md";
  if (isLgScreen) return "lg";
  if (isXlScreen) return "xl";
};

export default useCurrentScreenSize;
